import { createSelector } from 'reselect'

export const getVehiclePositions = state => state.vehiclePositions.getIn(['all', 'objects'])

export const createGetVehiclePositionByIDSelector = id => createSelector([getVehiclePositions], vehiclePositions => vehiclePositions.get(String(id)))

export const getVehiclePositionsFetching = state => state.vehiclePositions.getIn(['all', 'fetching'])
